export const go = async <T, E = any>(promise: Promise<T>): Promise<[T, null] | [null, E]> => {
  try {
    const result = await promise;

    return [result, null];
  } catch (error) {
    return [null, error];
  }
};

export const maxBy = <T>(arr: T[], callback: (value: T) => number) => {
  const mapped = arr.map(callback);
  const max = Math.max(...mapped);
  return arr[mapped.indexOf(max)];
};

export const minBy = <T>(arr: T[], callback: (value: T) => number) => {
  const mapped = arr.map(callback);
  const max = Math.min(...mapped);
  return arr[mapped.indexOf(max)];
};
